module.exports = __webpack_public_path__ + "static/media/Expired.e60eedf6.svg";